<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="申请人信息：" prop="applicantInfo">
            <el-input v-model="query.applicantInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="用户信息：" prop="userInfo">
            <el-input v-model="query.userInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <!-- <el-form-item label="用户身份：">
            <el-select v-model="query.userIdentity" placeholder="全部" clearable size="small" style="width: 120px;">
              <el-option v-for="item in identityList" :key="item.id" :label="item.name" :value="item.level" />
            </el-select>
          </el-form-item> -->
          <el-form-item label="充值类型：">
            <el-select v-model="query.rechargeType" placeholder="全部" clearable size="small" style="width: 120px;">
              <el-option v-for="item in rechargeTypeList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否有赠送：">
            <el-select v-model="query.hasGift" placeholder="全部" clearable size="small" style="width: 120px;">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="城市公司：" prop="cityName">
            <el-input v-model="query.cityName" placeholder="请输入城市公司" size="small" clearable />
          </el-form-item>
          <el-form-item label="收款银行：" prop="receivingBank">
            <el-input v-model="query.receivingBank" placeholder="请输入" size="small" clearable />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small" style="width: 120px;">
              <el-option label="提交时间" :value="0" />
              <el-option label="审核时间" :value="1" />
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始" end-placeholder="结束" style="margin-left: 10px;" />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({ pageNo: 1 })">
          <el-tab-pane label="待审核" name="0" />
          <el-tab-pane label="同意申请" name="1" />
          <el-tab-pane label="驳回申请" name="2" />
        </el-tabs>
        <div class="btn-box" v-if="!recordOnly">
          <el-button type="primary" plain size="mini" @click="handleExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName" style="width: 100%">
        <el-table-column label="申请人" prop="createdByRealName" align="center" width="100"></el-table-column>
        <el-table-column label="申请人身份" prop="createdByRoleNames" align="center" min-width="140"
          show-overflow-tooltip></el-table-column>
        <el-table-column label="申请人手机号" prop="createdByUserName" align="center" width="120">
        </el-table-column>
        <el-table-column label="订单号" prop="orderNumber" align="center" width="140" show-overflow-tooltip />
        <el-table-column label="充值用户信息" align="center" min-width="200">
          <template slot-scope="{ row }">
            {{ row.userRealName }}-{{ row.userLevelName }}-{{ row.userMobile }}
          </template>
        </el-table-column>
        <el-table-column label="业务线" prop="parentUserBusiness" align="center" width="140" show-overflow-tooltip />
        <el-table-column label="城市公司" prop="cityCompanyName" align="center" width="120" show-overflow-tooltip />
        <el-table-column label="充值账户" align="center" width="100">
          <template slot-scope="{ row }">
            {{ row.userMainId === 0 ? '主账户' : '子账户' }}
          </template>
        </el-table-column>
        <el-table-column label="入账账户" align="center" width="100">
          <template slot-scope="{ row }">
            {{row.userMainId>0?( row.auditStatus===10?(row.customerTypeWalletCredit===1?'主账户':'子账户'):
            (row.isUseParentWallet === 1 ? '主账户' : '子账户') ):'主账号'}}
          </template>
        </el-table-column>
        <el-table-column label="充值金额" align="center" width="100">
          <template slot-scope="{ row }">
            {{ formatAmount(row.orderAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="充值类型" prop="rechargeType" align="center" width="120" show-overflow-tooltip />
        <el-table-column label="赠送活动" prop="giftActivity" align="center" min-width="200" show-overflow-tooltip >
          <template slot-scope="{ row }">
            <span v-if="row.giveType === 1">{{row.xiaoduMoney}}零售价</span>
            <span v-else-if="row.giveType === 2">{{ row.goodsName }}*1件</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="收款银行" align="center" width="120" show-overflow-tooltip >
          <template slot-scope="{ row }">{{ getPayBankNames(row) }}</template>
        </el-table-column>
        <el-table-column label="凭证" align="center" width="100">
          <template slot-scope="{ row }">
            <span class="imgs" v-if="getVoucherImages(row).length > 0">
              <el-image v-for="(item, index) in getVoucherImages(row)" :key="index"
                style="width: 40px; height: 40px; margin-right: 4px;" :src="item"
                :preview-src-list="getVoucherImages(row)" />
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="支付单号" prop="payOrderNum" align="center" width="120">
          <template slot-scope="{ row }">{{ getPayOrderNos(row) }}</template>
        </el-table-column>
        <el-table-column label="申请原因" prop="orderNote" align="center" width="100" show-overflow-tooltip />
        <el-table-column label="提交时间" prop="createdTime" align="center" width="180" />
        <el-table-column v-if="activeName === '1'" label="审核时间" prop="auditTime" align="center" width="180" />
        <el-table-column v-if="activeName === '1'" label="审核人" prop="auditUserRealName" align="center" width="100" />
        <el-table-column v-if="activeName === '2'" label="驳回时间" prop="auditTime" align="center" width="180" />
        <el-table-column v-if="activeName === '2'" label="驳回原因" align="center" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.auditRemark || '-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="!recordOnly && activeName === '0'" label="操作" align="center" fixed="right" width="140">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleApprove(row)">同意</el-button>
            <el-button type="text" @click="handleReject(row)">驳回</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="!recordOnly && activeName === '1'" label="操作" align="center" fixed="right" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleReceiptInfo(row)">收款信息</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>

    <approve-dialog v-if="!recordOnly" ref="approveDialog" @approve="handleApproveConfirm" />
    <reject-dialog v-if="!recordOnly" ref="rejectDialog" @reject="handleRejectConfirm" />
    <receipt-info-dialog v-if="!recordOnly" ref="receiptInfoDialog" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import rechargeManualLedgerAuditApi from '@/api/finance/rechargeManualLedgerAudit'
import ApproveDialog from './approveDialog.vue'
import RejectDialog from './rejectDialog.vue'
import ReceiptInfoDialog from './receiptInfoDialog.vue'
import { formatDateStr } from '@/utils'

export default {
  components: {
    Pagination,
    ApproveDialog,
    RejectDialog,
    ReceiptInfoDialog
  },
  props: {
    /** 仅记录模式，不显示操作按钮 */
    recordOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        applicantInfo: undefined,
        userInfo: undefined,
        userIdentity: undefined,
        rechargeType: undefined,
        hasGift: undefined,
        cityName: undefined,
        receivingBank: undefined,
        timeType: undefined,
        auditStatus: undefined
      },
      dateTime: null,
      activeName: '0',
      identityList: [],
      rechargeTypeList: [] // 充值类型选项，可从后端接口获取
    }
  },
  created() {
    this.identityList = JSON.parse(localStorage.getItem('levelList') || '[]')
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 20,
        applicantInfo: undefined,
        userInfo: undefined,
        userIdentity: undefined,
        rechargeType: undefined,
        hasGift: undefined,
        cityName: undefined,
        receivingBank: undefined,
        timeType: undefined,
        auditStatus: undefined
      }
      this.dateTime = null
      this.doQueryList({ pageNo: 1 })
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize

      // 构建API参数，映射到后端接口参数名
      // 审核状态映射：'0'->0(待审核), '1'->10(已同意), '2'->20(已驳回)
      const auditStatusMap = {
        '0': '0',  // 待审核
        '1': '10', // 已同意
        '2': '20'  // 已驳回
      }
      const params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        auditStatus: auditStatusMap[this.activeName] || this.activeName
      }

      // 时间筛选
      if (this.dateTime && this.dateTime.length === 2) {
        if (this.query.timeType === 0 || this.query.timeType === undefined) {
          // 提交时间
          params.createdTimeStart = this.dateTime[0]
          params.createdTimeEnd = this.dateTime[1]
        } else if (this.query.timeType === 1) {
          // 审核时间
          params.auditTimeStart = this.dateTime[0]
          params.auditTimeEnd = this.dateTime[1]
        }
      }

      // 申请人信息关键字（姓名/手机号）
      if (this.query.applicantInfo) {
        params.keywordsCreatedBy = this.query.applicantInfo.trim()
      }

      // 用户信息关键字（姓名/手机号）
      if (this.query.userInfo) {
        params.keywordsUser = this.query.userInfo.trim()
      }

      // 用户身份等级ID
      if (this.query.userIdentity !== undefined && this.query.userIdentity !== null && this.query.userIdentity !== '') {
        params.userLevelId = this.query.userIdentity
      }

      // 充值类型
      if (this.query.rechargeType !== undefined && this.query.rechargeType !== null && this.query.rechargeType !== '') {
        params.rechargeType = this.query.rechargeType
      }

      // 是否赠送
      if (this.query.hasGift !== undefined && this.query.hasGift !== null && this.query.hasGift !== '') {
        params.isGift = this.query.hasGift === 1
      }

      // 城市公司名称
      if (this.query.cityName) {
        params.cityCompanyName = this.query.cityName.trim()
      }

      // 收款银行名称
      if (this.query.receivingBank) {
        params.receiveBankName = this.query.receivingBank.trim()
      }

      this.listLoading = true
      const apiMethod = this.recordOnly ? rechargeManualLedgerAuditApi.fetchRecordList : rechargeManualLedgerAuditApi.fetchList
      apiMethod(params)
        .then(data => {
          if (data && data.data) {
            this.list = data.data.list || data.data.records || []
            this.total = data.data.total || 0
          } else if (data && (data.list || data.records)) {
            this.list = data.list || data.records || []
            this.total = data.total || 0
          } else {
            this.list = []
            this.total = 0
          }
          // 处理时间字段，格式化为标准格式
          this.list = this.list.map(item => {
            // if (item.createdTime) {
            //   item.createdTime = formatDateStr(item.createdTime)
            // }
            if (item.auditTime) {
              item.auditTime = formatDateStr(item.auditTime)
            }
            return item
          }) 
        })
        .catch(() => {
          this.list = [ ]
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    
    formatUserInfo(row) {
      if (row.targetUserName && row.targetUserLevelName && row.targetUserMobile) {
        return `${row.targetUserName}-${row.targetUserLevelName}-${row.targetUserMobile}`
      }
      return row.rechargeUserInfo || row.userInfo || '-'
    },
   
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      return isNaN(num) ? val : num + '元'
    },
    getVoucherImages(row) {
      if (!row) return []
      if (row.voucherList && row.voucherList.length > 0) {
        return row.voucherList.map(item => item.payImg).filter(Boolean)
      }
      return []
    },
    getPayOrderNos(row) {
      if (!row) return '-'
      if (row.voucherList && row.voucherList.length > 0) {
        return row.voucherList.map(item => item.payNum ).filter(Boolean).join(', ')
      }
      return  '-'
    },
    getPayBankNames(row) {
      if (!row) return '-'
      if (row.voucherList && row.voucherList.length > 0) {
        return row.voucherList.map(item => item.payBank ).filter(Boolean).join(', ')
      }
      return  '-'
    },
    handleApprove(row) {
      this.$refs.approveDialog.handleCreate(row)
    },
    handleApproveConfirm(params, callback) {
      rechargeManualLedgerAuditApi
        .approve(params)
        .then(() => {
          this.$message.success('审核通过')
          this.doQueryList({})
          if (callback) callback()
        })
        .catch(err => {
          this.$message.error(err.msg || '审核失败')
          if (callback) callback()
        })
    },
    handleReject(row) {
      this.$refs.rejectDialog.handleCreate(row)
    },
    handleRejectConfirm(params, callback) {
      rechargeManualLedgerAuditApi
        .reject(params)
        .then(() => {
          this.$message.success('已驳回')
          this.doQueryList({})
          if (callback) callback()
        })
        .catch(err => {
          this.$message.error(err.msg || '驳回失败')
          if (callback) callback()
        })
    },
    handleReceiptInfo(row) {
      this.$refs.receiptInfoDialog.handleCreate(row)
    },
    handleExport() {
      this.$router.push('/export/list?code=EEForTuitionOrderV2')
    }
  }
}
</script>

<style scoped>
.imgs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-right-side {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}
</style>
